var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9601 5.30586C18.9599 4.96966 18.8294 4.64662 18.596 4.40464C18.3626 4.16266 18.0445 4.02058 17.7085 4.00826V4.00586H4.32969V4.00946C4.30649 4.00826 4.28349 4.00586 4.26009 4.00586C3.99124 4.00603 3.72905 4.08956 3.50964 4.24494C3.29023 4.40032 3.12439 4.6199 3.03496 4.87344C2.94553 5.12699 2.93692 5.40202 3.01029 5.66067C3.08367 5.91932 3.23544 6.14885 3.44469 6.31766L9.47269 12.3455L9.47249 16.0653V16.0961H9.47549C9.48054 16.2108 9.51462 16.3223 9.57454 16.4203C9.63446 16.5182 9.71826 16.5993 9.81809 16.6561L9.81629 16.6593L11.3907 17.5683C11.4039 17.5775 11.4185 17.5841 11.4323 17.5923L11.4379 17.5955C11.5383 17.6535 11.6535 17.6891 11.7779 17.6891C11.8676 17.6891 11.9565 17.6714 12.0394 17.6371C12.1223 17.6028 12.1976 17.5525 12.261 17.489C12.3245 17.4256 12.3748 17.3502 12.4091 17.2673C12.4435 17.1844 12.4611 17.0956 12.4611 17.0059C12.4611 16.9879 12.4571 16.9709 12.4559 16.9533H12.4611V12.3511L18.5445 6.26786L18.5385 6.26186C18.6713 6.14056 18.7774 5.99289 18.85 5.82829C18.9226 5.66369 18.9601 5.48576 18.9601 5.30586ZM7.40989 6.60586H7.41269L7.41289 6.60886L7.40989 6.60586Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.7b87859674b4596d2308a382696ec1c1.svg";
export { ForwardRef as ReactComponent };